import { i18n } from "../globalization/i18n.js";
import { BasePage } from "./BasePage.js";

export class Error404Page extends BasePage {

    constructor(parent, options) {

        super(parent, options);

        this.pageTitle = i18n.t('page.error_404.title');
        this.errorDescription = i18n.t('page.error_404.description');
        this.errorRecomendation = i18n.t('page.error_404.recomendation');

    };

}
